module.exports = __webpack_public_path__ + "img/center.a45e4c09.png";